export class Schema {
    constructor(
        readonly key: string,
        readonly name: string,
        readonly json: string,
        readonly isEditor?: boolean
    ) {
    }
}
